import { Reducer } from 'react';
import { StagedLinkActions, StagedLinkState, UpdateUtmsSettingsAction } from './StagedLinkActions';
import { ImmutabilityContext } from '../states/effects/customImmutabilityContext';
import { cloneDeep } from 'lodash';
import { LinkClickTracking } from '../../../models/graphql';
import { IsKeyOfUtmInput, makeFinalLink } from '../states/reducers/link.reducer';

export const StagedLinkReducer: Reducer<StagedLinkState, StagedLinkActions> = (state, action) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { type, payload } = action;
  switch (type) {
    case 'setInitialLink':
      return updateImmutable(state, {
        loading: { $set: true },
        initialUrl: { $set: payload },
        linkMetadata: { $set: undefined }
      });
    case 'setLinkPreviewStatus':
      return updateImmutable(state, {
        removePreview: { $set: !payload }
      });
    case 'setLinkDestination':
      return updateImmutable(state, {
        destination: { $set: payload },
        url: { $set: makeFinalLink({ ...state, destination: payload }) }
      });
    case 'setKeepExistingUtmsStatus':
      const { value, initialUtms } = payload;
      return updateImmutable(state, {
        removeUtm: { $set: !value },
        utmTracking: { $merge: initialUtms },
        url: {
          $set: makeFinalLink({
            ...state,
            removeUtm: !value,
            utmTracking: state.utmTracking ? { ...state.utmTracking, ...initialUtms } : null
          })
        }
      });
    case 'updateUtmsSettings':
      let keys: Array<keyof UpdateUtmsSettingsAction['payload']> = [];
      for (const key of Object.keys(payload)) {
        if (IsKeyOfUtmInput(key)) {
          keys = [...keys, key];
        }
      }
      const updated = updateImmutable<StagedLinkState>(state, {
        utmTracking: current => {
          let updated = updateImmutable(current, {});
          keys.forEach(k => {
            const state = cloneDeep(updated);
            updated = updateImmutable(state, {
              [k]: { $set: payload[k] }
            });
          });
          return updated;
        }
      });
      return updateImmutable(updated, {
        url: { $set: makeFinalLink(updated) }
      });
    case 'setTrackingCampaignStatus':
      return updateImmutable(state, {
        addUtm: { $set: payload },
        url: { $set: makeFinalLink({ ...state, addUtm: payload }) }
      });
    case 'setClickTracing':
      return updateImmutable(state, {
        useBitly: { $set: payload === LinkClickTracking.BITLY },
        url: { $set: makeFinalLink({ ...state, useBitly: payload === LinkClickTracking.BITLY }) }
      });
    case 'updateLinkMetadata': {
      return updateImmutable<StagedLinkState>(state, {
        loading: { $set: false },
        useBitly: { $apply: current => (payload && payload.isBitlink ? false : current) },
        linkMetadata: { $set: payload },
        url: { $set: makeFinalLink({ ...state, linkMetadata: payload }) }
      });
    }
    case 'setLoading':
      return updateImmutable(state, {
        loading: { $set: payload }
      });
    case 'revertInitialLink':
      const { initialUrl, linkMetadata, url } = payload;
      return updateImmutable(state, {
        initialUrl: { $set: initialUrl },
        linkMetadata: { $set: linkMetadata },
        loading: { $set: false },
        url: { $set: url }
      });
    default:
      return state;
  }
};
